<div class="confirmation-dialog-container">
  <wcg-dialog
    [title]="data.title"
    [description]="data.message"
    [size]="data.dialogSize"
    >
    <div secondary>
      <button
        color="primary"
        mat-button
        class="mdc-cancel-button"
        (click)="cancel()"
        >
        Cancel
      </button>
    </div>
    <div primary>
      @if (data.isDefault ? data.dataList.length : true) {
        <button
          wcg-button
          mat-flat-button
          color="warn"
          [disabled]="!selectedDefaultvalue && data.isDefault"
        (click)="
          deleteContactInfo(
            data.isDefault ? 'update_and_remove' : 'remove',
            selectedDefaultvalue
          )
        "
          >
          {{ data.buttonTitle }}
        </button>
      }
    </div>
    @if (data.isDefault) {
      <div content>
        <div class="icon-with-text">
          <mat-icon class="alertIcon">warning</mat-icon>
          <span class="text">{{ data.alertMessage }}</span>
        </div>
        @if (data.dataList.length) {
          <div class="mt-20">
            <mat-label
              ><strong>{{ data.updateTitle }}</strong></mat-label
              ><br>
              @for (item of data.dataList; track item) {
                <mat-radio-group
                  [(ngModel)]="selectedDefaultvalue"
                  >
                  <mat-radio-button color="primary" [value]="item.id">{{
                    item.value
                    }}</mat-radio-button
                    ><br />
                  </mat-radio-group>
                }
              </div>
            }
          </div>
        }
      </wcg-dialog>
    </div>
